import { IProjectCostInput } from "@/pages/ForecastingPage";

export const sumAmounts = (entries: { amount: number }[]) =>
  entries.reduce((sum, entry) => sum + entry.amount, 0);

export const getForecastTotal = (
  projectCosts: IProjectCostInput,
  variations: { utilizedAmount: number }[]
) =>
  sumAmounts(projectCosts.labourCosts) +
  sumAmounts(projectCosts.plantCosts) +
  sumAmounts(projectCosts.materialCosts) +
  sumAmounts(projectCosts.subcontractorCosts) +
  variations.reduce(
    (sum, v) => sum + (v.utilizedAmount > 0 ? v.utilizedAmount : 0),
    0
  );

export const formatAmount = (amount: number) =>
  amount.toLocaleString("en-GB", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

const toPence = (amount: number) => Math.round(amount * 100);

/**
 * How much `actual` exceeds `estimated`, compared in whole pence so floating-point
 * drift (e.g. 0.1 + 0.2 > 0.3) never reads as "over by £0.00". 0 when not over.
 */
export const getOverEstimateAmount = (actual: number, estimated: number) =>
  estimated > 0 ? Math.max(0, toPence(actual) - toPence(estimated)) / 100 : 0;
